// import React from 'react';

const Header = ({ children }) => {
   return (
      children
   );
};

export default Header;
